module.exports = __webpack_public_path__ + "img/dm.61817484.svg";